import { html } from 'lit';
import { EllipsisVertical } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-more-vertical')
export class PdsIconMoreVertical extends PdsIcon {
  @state()
  icon = EllipsisVertical;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
